import Patientdetailst1 from "./patientdetailst1";
import Patientvisitt2 from "./patientvisitt2";
import Patientpaymentt3 from "./patientpaymentt3";
import Sidebaradmin from "./sidebaradmin"

function Patientdetails (){
    return(
        <>
        <Sidebaradmin></Sidebaradmin>
        <Patientdetailst1></Patientdetailst1>
        <Patientvisitt2></Patientvisitt2>
        <Patientpaymentt3></Patientpaymentt3>
        </>

    )
}
export default Patientdetails;